// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/sprout.js';

import { paths } from '../generated/sprout';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('sprout', Original, paths);
